import {
  ExperienceDto,
  ExperiencePageTargetingDto,
  OrganizationDto,
  RedirectDto,
} from "@intelligems/ig-types";
import { getPreviewPathShared } from "@intelligems/ig-utils";

import { ExperienceFe } from "../types/schemas/experiences";

export const getPreviewThemeId = (themeRedirects: RedirectDto[]) => {
  return themeRedirects !== undefined &&
    themeRedirects.length > 0 &&
    themeRedirects[0].queryParams.length &&
    themeRedirects[0].queryParams[0].value !== undefined
    ? themeRedirects[0].queryParams[0].value
    : "";
};

export const generatePreviewLink = ({
  organization,
  experience,
  previewThemeId,
  variationId,
  addSsTrafficDetails,
  hideExperienceId,
  customDevicePath,
  builderModeEntity,
  authToken,
  useOriginUrl,
  redirects,
  pageTargeting,
}: {
  organization: OrganizationDto;
  experience: ExperienceFe | ExperienceDto;
  variationId?: string;
  previewThemeId?: string;
  addSsTrafficDetails?: boolean;
  hideExperienceId?: boolean;
  customDevicePath?: string;
  builderModeEntity?: string;
  authToken?: string | null;
  useOriginUrl?: boolean;
  redirects?: RedirectDto[];
  pageTargeting?: ExperiencePageTargetingDto[];
}) => {
  const localPath = customDevicePath
    ? customDevicePath
    : experience.devicePreview?.path && experience.devicePreview.path !== "/"
      ? experience.devicePreview.path
      : useOriginUrl
        ? getPreviewPathShared(redirects || [], pageTargeting || [], true)
        : experience.previewPath;
  const previewDetails = hideExperienceId ? "" : `?ig-preview=${experience.id}`;
  const getVariationId = variationId ? `&igTg=${variationId}` : "";

  const extraDetails = addSsTrafficDetails
    ? `&ig-ss=true&ig-preview-traffic=true`
    : "";

  const getPreviewThemeId = previewThemeId
    ? `&preview_theme_id=${previewThemeId}`
    : "";

  const builderModeDetails =
    builderModeEntity && authToken
      ? `&ig-builder-mode=builder&ig-builder-entity=${builderModeEntity}&ig-auth-token=${authToken}`
      : "";

  let url =
    `${
      localPath?.includes("https://")
        ? ""
        : (organization.domain ?? organization.shopId)
    }${localPath?.replace("https://", "") || ""}` +
    previewDetails +
    getPreviewThemeId +
    extraDetails +
    getVariationId +
    builderModeDetails;
  if (!url.includes("https://")) {
    url = "https://" + url;
  }

  return url;
};
